

// jQuery(document).ready(function(){ 
  
//   	jQuery('#product-select-4334047363185productproduct-template-option-2').on('change', function() {
      
//       var op = jQuery(this).val();
//       alert("change");
      
      
//     });
 
// });



// });

function get_products_list(collection){
	var active = document.querySelector('.product-collections__list-item.active')
    active.classList.remove('active')
    var new_active = document.querySelector(`[data-handle="${collection}"] h4`);
    new_active.classList.add('active')
    fetch("https://lash-blvd.myshopify.com/collections/"+ collection +"/products.json")
        .then(response => response.json())
        .then(data => {
            var wrapper = document.createElement("div");
            wrapper.className = 'product-collections__item-list__wrapper'
            if (data.products.length > 6){
              var products_to_show = data.products.slice(0,6)
            } else {
              var products_to_show = data.products
            }
            products_to_show.forEach(product => {
                
                var item = document.createElement("div");
                item.className = 'product-collections__item'

                var item_a =  document.createElement("a");
                item_a.href = '/products/' + product.handle

                var item_img_container =  document.createElement("div");
                var item_img = document.createElement("img");
                item_img.src = product.images[0].src
                item_img.alt = product.title

                var item_title = document.createElement("h4");
              
                
                var item_title_a = document.createElement("a");
                item_title_a.href = '/products/' + product.handle
                item_title_a.textContent = product.title
                
                var current_variant
                if (product.variants.length > 1){
                  min_price = Math.min(...product.variants.map(variant => variant.price))
                  current_variant = product.variants.filter(variant => variant.price == min_price)[0]
                } else {
                  current_variant = product.variants[0]
                }
                var item_price = document.createElement("h4");
                item_price.className = 'product-collections__item-price'
                if (current_variant.compare_at_price > current_variant.price){
                  item_price.innerHTML = '<span class="reduced_price"> $' + current_variant.price + '</span>  <span class="compare_at_price"> $' + current_variant.compare_at_price + '</span>'
                } else {
                  item_price.innerHTML = '<span> $' + current_variant.price + '</span>'
                }

                item_img_container.appendChild(item_img)
                item_a.appendChild(item_img_container)
                item_title_a.appendChild(item_title)
                item.appendChild(item_a)
                item.appendChild(item_title_a)
                item.appendChild(item_price)
                wrapper.appendChild(item)
                // tag.appendChild(text);
                // var element = document.getElementById("new");
                // element.appendChild(tag);
            });
            var old_product_wrapper = document.getElementsByClassName('product-collections__item-list__wrapper')
            for (var i = old_product_wrapper.length - 1; i >= 0; --i) {
                old_product_wrapper[i].remove();
            }

            var product_list = document.getElementsByClassName('product-collections__item-list')
            product_list[0].appendChild(wrapper)
        });
    }

$(document).ready(function(){
		$(".btn-single-description").click( function() {
      $('.btn-collapsi').toggle(1000); //muestro mediante clase
      $('#max').toggle();
      $('#minus').toggle();
		});
});


$(document).ready(function(){
  if($(window).width() < 500){
    if($('body').hasClass('product')){
        $('[itemprop="description"]').css('display', 'none'); 
    	$('[itemprop="description"]').clone().insertAfter('[action="/cart/add"]');
        $('[action="/cart/add"] + [itemprop="description"]').css('display', 'block');
  	}
  }
  
});